import type { FC } from "react";
import { useEffect, useState } from "react";
import {
    INCLUDE_SUBDOMAINS,
    TIME_GRANULARITY,
    UNBOUNCED_VISITS,
    VERIFIED_DATA,
    getBooleanFilterItems,
    getTimeGranularityItems,
} from "./components/consts";
import { find, isNil } from "lodash";
import { getWebsiteHeaderData } from "app/components/dashboard/widget-wizard/utils/dashboardWizardUtils";
import { GenericDropdownFilter } from "./components/GenericDropdownFilter";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

interface IFilterObject {
    [UNBOUNCED_VISITS]: string;
    [INCLUDE_SUBDOMAINS]: string;
    [TIME_GRANULARITY]: string;
    [VERIFIED_DATA]: string;
}

export const EngagedVisitsSupportGraphWidgetFilters: FC<any> = (props) => {
    const { widgetFilters: filterObject, changeFilter: onFilterChangeCallback, widgetKeys } = props;

    const [showGAFilter, setShowGAFilter] = useState(false);

    useEffect(() => {
        const checkGAStatus = async () => {
            const res = await getWebsiteHeaderData(widgetKeys);
            setShowGAFilter(!!find(res, { hasGaToken: true }));
        };
        checkGAStatus();
    }, [widgetKeys]);

    // unbounced and GA data can't be fetched simultaneously
    const handleSpecialCases = (newData, filterName, value) => {
        const isValueTrue = value.toLowerCase() === "true";
        const isUnbouncedFilter = filterName === UNBOUNCED_VISITS;

        if (isValueTrue) {
            newData[isUnbouncedFilter ? VERIFIED_DATA : UNBOUNCED_VISITS] = "false";
        }
    };

    const onFilterChange = (filterName: keyof IFilterObject, value: string) => {
        const newData = { ...filterObject, [filterName]: value };

        handleSpecialCases(newData, filterName, value);

        const updatedFilters = Object.entries(newData).map(([key, value]) => ({
            name: key,
            value,
        }));

        onFilterChangeCallback(updatedFilters);
    };

    const convertBooleanToString = (value) => value.toString();

    return (
        <div
            key="dynamicFiltersContainer"
            className="filters"
        >
            <GenericDropdownFilter
                titleKey="TimeGranularity"
                items={getTimeGranularityItems()}
                selectedId={filterObject[TIME_GRANULARITY] ?? GranularityNames.DAILY}
                onSelect={(value) => onFilterChange(TIME_GRANULARITY, value.id)}
            />
            <GenericDropdownFilter
                titleKey={INCLUDE_SUBDOMAINS}
                items={getBooleanFilterItems()}
                selectedId={filterObject[INCLUDE_SUBDOMAINS] ?? "true"}
                onSelect={(value) => onFilterChange(INCLUDE_SUBDOMAINS, value.id)}
            />
            <GenericDropdownFilter
                titleKey={UNBOUNCED_VISITS}
                items={getBooleanFilterItems()}
                selectedId={
                    isNil(filterObject[UNBOUNCED_VISITS])
                        ? "false"
                        : convertBooleanToString(filterObject[UNBOUNCED_VISITS])
                }
                onSelect={(value) => onFilterChange(UNBOUNCED_VISITS, value.id)}
            />
            {!!widgetKeys?.length && showGAFilter ? (
                <GenericDropdownFilter
                    titleKey={VERIFIED_DATA}
                    items={getBooleanFilterItems()}
                    selectedId={
                        isNil(filterObject[VERIFIED_DATA])
                            ? "false"
                            : convertBooleanToString(filterObject[VERIFIED_DATA])
                    }
                    onSelect={(value) => onFilterChange(VERIFIED_DATA, value.id)}
                />
            ) : null}
        </div>
    );
};
